import { Icon, Card, Link } from '@iwoca/orion';
import { useMediaQuery } from '../../../customHooks/useMediaQuery';

export const ReferBanner = () => {
    const isMobile = useMediaQuery('(max-width: 624px)');

    if (isMobile) {
        return (
            <Card className="grid grid-cols-[min-content_1fr] gap-s bg-[#EAF1FB]">
                <Icon
                    icon="rocket"
                    className="fill-core-40"
                    width={21}
                    height={21}
                />
                <Link href="tel:02037780549" className="text-left text-s">
                    Call us to refer a supplier and each get paid £100{' '}
                    <Icon icon="angleRight" className="fill-primary-40" />
                </Link>
            </Card>
        );
    }

    return (
        <Card className="mb-xl grid grid-cols-1 gap-m px-l py-xl text-m font-reg">
            <Icon
                icon="multipleUsersOutline"
                className="fill-success-drk"
                width={32}
                height={32}
            />
            <p className="m-0 font-bold">
                Get rewarded for recommending iwocaPay
            </p>
            <p className="m-0 text-s">
                Recommend iwocaPay to a supplier and you’ll both get a £100
                voucher of your choice once they’re set up.
            </p>
            <div className="flex items-center text-left">
                <Link href="tel:02037780549" className="text-s">
                    Call 0203 778 0549
                </Link>
                <Icon icon="angleRight" className="fill-primary-40" />
            </div>
        </Card>
    );
};
